var mulberrySelectors = {
   addToCart: '[data-add-to-cart-trigger]',
   changeQuantity: '[data-update-quantity]',
   deleteFromAjaxCart: '.ajax-cart__delete',
   deleteFromCart: '.cart__remove',
   addToCartBtn: '.purchase-details'
  }


var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

async function mulberryInit() {    
	var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
	var product = response.product;
  	var selectedVariant = product.variants.find(i => i.id == mulberryShop.selectedVariantId)
    var selectedWarranty
    
    var offers = await mulberry.core.getWarrantyOffer({
      id: selectedVariant.id,
      title: product.title,
      price: selectedVariant.price,
      detail: product
  })
    
    if(offers.length === 0) {
    	return
    } 
  
    
  let divContainer = document.createElement('div')
  let mulberryDiv = document.createElement('div')
  divContainer.setAttribute('style', 'display:flex; flex-direction: column; width: 362px;')
  mulberryDiv.classList.add('mulberry-inline-container')
  mulberryDiv.setAttribute('style', 'padding-top: 10px; width: 100%;')
  divContainer.append(mulberryDiv)
  let btn = document.querySelector(mulberrySelectors.addToCartBtn)
  btn.insertAdjacentElement('afterbegin', divContainer)
    
  window.pdpInline = await mulberry.inline.init({
    layout: {
    	logo: false
  	},
    offers: offers, 
    settings: mulberry.core.settings,
    selector: '.mulberry-inline-container',
    onWarrantyToggle: async function(warranty) {
      mulberry.inline.isSelected = warranty.isSelected
      if(warranty.isSelected) {
      	selectedWarranty = warranty.offer
      }
      else {
        selectedWarranty = null
      }
    }
  })  
  
  document.querySelector(mulberrySelectors.addToCart).addEventListener('click', addWarrantyToCart)
  
  async function addWarrantyToCart() {
    if (selectedWarranty) {
      const result = await mulberryShop.getWarrantyVariant(selectedWarranty);
      if (selectedVariant) {
      	setTimeout(async function() {
          await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: selectedVariant.id}, selectedWarranty);
          await removeAndSyncWarranties()
        }, 2000)
      } else {
      	setTimeout(async function() {
          await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {title: product.title, variantId: mulberryShop.selectedVariantId}, selectedWarranty);
          await removeAndSyncWarranties()
      	}, 2000)
      }
     selectedWarranty = null 
     mulberry.inline.deselectOffer()
    } else {
      setTimeout(async function() {
          await removeAndSyncWarranties()
      	}, 2000)
    }
  }
  
  document.addEventListener('mulberry-shopify:variant-change', async function(event) {
    var response = await mulberryShop.getProductData(mulberryShop.getProductUrl())
	var product = response.product;
    selectedVariant = (product.variants.find(i => i.id == mulberryShop.selectedVariantId)) ? (product.variants.find(i => i.id == mulberryShop.selectedVariantId)) : (null) 
	
    if (selectedVariant) {
        offers = await mulberry.core.getWarrantyOffer({
				id: selectedVariant.id,
                title: product.title,
                price: selectedVariant.price,
                detail: product
			})
    } else {
        offers = await mulberry.core.getWarrantyOffer({
				id: mulberryShop.selectedVariantId,
                title: product.title,
                price: product.variants[0].price,
                detail: product
			})
    }
    
    mulberry.inline.updateOffer(offers)
})
}
  

  async function removeAndSyncWarranties() {
  	await fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (cart) {
      cart.json().then(function (firstCart) {
        mulberryShop.removeDetachedWarranty(firstCart)// Remove Warranties First 
        .then(newCart => {
          mulberryShop.cart.syncQuantities(newCart)// Sync Quantities Second
          .then(function(newCart) {
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
              Shopify.theme.jsAjaxCart.updateView();
            }
                $('[data-bind="itemCount"]').text(newCart.item_count)
            	$('.ajax-cart__details-wrapper div').children()[1].innerHTML=formatter.format(newCart.total_price/100)
            	$('.cart__subtotal').text(`${formatter.format(newCart.total_price/100)}`)
          })
        })
      });
    })
    setTimeout(async function() {
      	await initCart()
      }, 700)
}	


async function initCart() {
 await mulberryShop.cart.init()
 await mulberryShop.cart.render()
}
  
document.addEventListener('mulberry-shopify:loaded', async function() {
 if(window.location.href.indexOf("products") != -1 ) {
  	await mulberryInit()
    await initCart()
    setupAjaxListeners()
  } else {
  	await initCart()
    await removeAndSyncWarranties()
    setupAjaxListeners()
  }
   
})

// document.addEventListener('mulberry-shopify:line-item-data', async function() {
//         if (document.querySelector(mulberrySelectors.deleteFromAjaxCart)){
//     		document.querySelector(mulberrySelectors.deleteFromAjaxCart).addEventListener('click', async function() {
//          		await removeAndSyncWarranties()
//         })
// 	}
// })

// document.addEventListener('mulberry-shopify:cart-update', function() {
//         if (document.querySelector(mulberrySelectors.deleteFromCart)){
//     		document.querySelector(mulberrySelectors.deleteFromCart).addEventListener('click', async function() {
//          		await removeAndSyncWarranties()
//                 await initCart()
//         })
        
//         if (document.querySelector(mulberrySelectors.addToCart)) {
//         	document.querySelector(mulberrySelectors.addToCart).addEventListener('click', async function() {
//               await removeAndSyncWarranties()
//               await initCart()
//             })
//         }
// 	}
// })

 document.addEventListener('mulberry-shopify:warranty-added', async function() {
         if(window.location.href.indexOf("/cart") != -1 ) {
            setTimeout(function() {
              window.location.reload()
            }, 1000)
         } else {
           await removeAndSyncWarranties()
         }
    });


function setupAjaxListeners() {
    // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
    // Since we cant create globals we test for the XMLHttpRequest overwrite
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock fetch() in order to determine if we should mock then() as well
        var mbFetch = fetch;
        fetch = function() {
            var url = arguments[0];
            var body = '';
            if ((arguments.length > 1) && (typeof arguments[1].body !== 'undefined'))
            {
                body = arguments[1].body;
            }
            var promise = mbFetch.apply(this,arguments);
            if (url && url.indexOf('cart/change') !== -1) {
                //If its a product being added to cart we add a function to track it
                promise = promise.then(function (response) {
                    if (response.ok) {
                        //trackAjaxAddToCart(body, response.clone().json());
                    }
                    return response;
                });
            }
            return promise;
        };
    }
    if (typeof XMLHttpRequest.prototype.mbOpen === 'undefined') {
        // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
        XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
        XMLHttpRequest.prototype.open = function () {
            var url = arguments[1];
            if (url && ( (url.includes('cart/change')) || (url.includes('cart/add')) || (url.includes('cart/update')) )) {
                // We mock the instance's send method if the request is to the "add to the cart" url.
                this.mbSend = this.send;
                this.send = function (value) {
                    try {
                        if (value) {
                            var self = this; // The xhttp request object

                            var trackOnSuccess = function () {
                                if (self.readyState === 4 && self.status === 200) {
                                  if(self.responseURL !== undefined) {
                                    if(self.responseURL.includes('cart/add')){
                                      addCustomEvent = new CustomEvent("shopify:cart-add")
                                      document.dispatchEvent(addCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/change')) {
                                      changeCustomEvent = new CustomEvent("shopify:cart-change")
                                      document.dispatchEvent(changeCustomEvent)
                                    }
                                    if(self.responseURL.includes('cart/update')) {
                                      updateCustomEvent = new CustomEvent("shopify:cart-update")
                                      document.dispatchEvent(updateCustomEvent)
                                    }
                                  }
                                }
                            };

                            if (typeof self.addEventListener !== 'undefined') {
                                self.addEventListener('readystatechange', trackOnSuccess);
                            } else {
                                if (typeof self.onreadystatechange !== 'undefined' && self.onreadystatechange !== null) {
                                    // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                                    self.mbOnreadystatechange = self.onreadystatechange;
                                    self.onreadystatechange = function () {
                                        self.mbOnreadystatechange();
                                        trackOnSuccess();
                                    };
                                } else {
                                  // If there is no onreadystatechange callback, we can safely set it.
                                  self.onreadystatechange = trackOnSuccess;
                                }
                            }
                        }
                    } catch(e) {
                        // if something goes wrong tracking the addToCart,
                        // we just ignore it and prevent the website from breaking.
                        console.log(e);
                    }
                    this.mbSend(value);
                };
            }
            this.mbOpen.apply(this, arguments);
        };
    }
}


document.addEventListener('shopify:cart-change', async function() {
  await removeAndSyncWarranties()
})